module.exports = __webpack_public_path__ + "img/champions.00cc99fa.svg";